import clsx from 'clsx';
import styles from './NoResultsText.module.css';

export function NoResultsText({ className = '', children = 'No results found' }) {
  return <p className={clsx(styles.text, className)}>{children}</p>;
}
